<template>
  <div class="login_remis_customer">
    <div class="selectLanguage">
      <select
        @change="changeLanguage"
        v-model="usedLang"
        class="w-100 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
      >
        <option value="fr">FR</option>
        <option value="en">EN</option>
      </select>
      <!-- <select @change="changeLanguage" class="w-lg-100 mb-3 mb-md-3 mb-lg-0">
        <option disabled value="en">
          {{ $t("text.cMasterLayout.selectLanguage") }}
        </option>
        <option value="fr">FR</option>
        <option value="en">EN</option>
      </select> -->
    </div>
    <div class="container">
      <div class="row">
        <transition name="right-slide" appear>
          <div class="col-md-6 login_remis_first_section">
            <div v-if="windowLoc == 'localhost' || windowLoc == 'efueling'">
              <img
                src="https://epump.com.ng/images/logo2.svg"
                class="company_logo"
                width="120"
              />

              <div class="login_remis_text">
                {{ $t("text.signUp.manageFueling") }}
              </div>
            </div>
            <div v-else>
              <div class="partners_div mb-4" style="margin-right: 17%">
                <div>
                  <img
                    src="@/assets/img/FuelMetrics.png"
                    class="mr-4"
                    width="100px"
                  />
                </div>
                <div class="vl"></div>
                <div>
                  <img
                    :src="[
                      windowLoc == 'interswitchenergy'
                        ? require('@/assets/img/ISW- Logo.png')
                        : windowLoc == 'rainoil'
                        ? require('@/assets/img/rainoil_1a.jpg')
                        : windowLoc == 'eterna'
                        ? require('@/assets/img/Eterna-logo_1a.jpg')
                        : windowLoc == 'bovas'
                        ? require('@/assets/img/bovas_1a.png')
                        : 'https://epump.com.ng/images/logo2.svg',
                    ]"
                    class="ml-4"
                    width="100px"
                    height="50px"
                  />
                </div>
              </div>
            </div>

            <div class="row m-hide">
              <div class="col-validmd-6 col-sm-12 login-remis-img">
                <img src="../../assets/img/cars.png" />
              </div>
              <div class="col-md-6 col-sm-12 login-remis-img">
                <img src="../../assets/img/nossel.png" />
              </div>
              <div class="mt-3 col-md-6 col-sm-12 login-remis-img">
                <img src="../../assets/img/motorbike-fleet.png" />
              </div>
              <div class="mt-3 col-md-6 login-remis-img">
                <img src="../../assets/img/car-speed.png" />
              </div>
            </div>
          </div>
        </transition>
        <div class="col-md-6">
          <transition name="slide-fade" mode="out-in" appear>
            <div class="login_remis_section">
              <h4
                class="pt-4"
                :style="[
                  windowLoc == 'interswitchenergy'
                    ? { color: '#11386a' }
                    : windowLoc == 'rainoil'
                    ? { color: '#0a0044' }
                    : windowLoc == 'eterna'
                    ? { color: '#007236' }
                    : windowLoc == 'bovas'
                    ? { color: '#ffc905' }
                    : null,
                ]"
              >
                {{ $t("text.signUp.signIn") }}
              </h4>
              <form>
                <div class="remis_login_field">
                  <label>{{ $t("text.login.emailAddress") }}</label>
                  <input
                    type="email"
                    v-model="email"
                    :placeholder="$t('text.omit.enterEmail')"
                    @blur="checkEmail"
                    :class="!emailFormatGood ? 'red_back' : null"
                  />
                </div>
                <div class="remis_login_field">
                  <label>{{ $t("text.login.password") }}</label>
                  <div class="position-relative">
                    <input
                      type="password"
                      :placeholder="$t('text.omit.enterPass')"
                      ref="pass"
                      v-model="password"
                      class="w-100"
                    />
                    <i
                      class="cursor-pointer fa eye-icon"
                      aria-hidden="true"
                      :class="[showEye ? 'fa-eye-slash' : 'fa-eye']"
                      @click="toggleEyeIcon"
                    ></i>
                  </div>
                </div>
                <div class="pb-3 text-right">
                  <router-link
                    :to="{ name: 'reset_password' }"
                    class="mt-0 remis_sign_up_link font-weight-normal"
                    >{{ $t("text.login.forgotPassword") }}</router-link
                  >
                </div>
                <button
                  @click="login"
                  :disabled="disableButton"
                  :class="disableButton ? 'login_loading' : null"
                >
                  <p v-if="!disableButton">{{ $t("text.signUp.signIn") }}</p>
                  <div class="loader_spinner">
                    <pulse-loader
                      :color="color"
                      size="15px"
                      v-if="disableButton"
                    ></pulse-loader>
                  </div>
                </button>
                <p class="text-center">
                  {{ $t("text.login.noAccount") }}
                  <router-link
                    :to="{ name: 'signup' }"
                    class="remis_sign_up_link"
                    >{{ $t("text.signUp.signIn") }}</router-link
                  >
                </p>
              </form>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import configObject from "@/config";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  title: "Login - Epump Portal",
  components: {
    PulseLoader,
  },
  data() {
    return {
      color: this.$store.getters.loaderColor,
      email: "",
      password: "",
      disableButton: false,
      emailFormatGood: true,
      showEye: false,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      allowedEmails: [
        "demo1@gmail.com",
        "demo2@gmail.com",
        "Demo3@gmail.com",
        "demo4@gmail.com",
      ],
    };
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;
    // console.log(this.$store.getters.getLanguage);
  },

  methods: {
    changeLanguage(e) {
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    toggleEyeIcon() {
      this.showEye = !this.showEye;
      this.$refs.pass.type === "text"
        ? (this.$refs.pass.type = "password")
        : (this.$refs.pass.type = "text");
    },
    checkEmail() {
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3500,
        });
        this.emailFormatGood = false;
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        this.emailFormatGood = false;
        return;
      }
      this.emailFormatGood = true;
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    login($event) {
      $event.preventDefault();

      this.checkEmail();
      if (!this.emailFormatGood) return;
      if (!this.password) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMissing"),
          type: "error",
          duration: 2000,
        });
        return;
      }

      this.disableButton = true;
      let data = {
        userName: this.email,
        password: this.password,
      };
      this.axios
        .post(`${configObject.apiBaseUrl}/Account/Login`, data)
        .then((response) => {
          let userDetails = response.data;
          userDetails.roles = userDetails.role.split(",");
          this.disableButton = false;

          if (
            userDetails.roles &&
            !userDetails.roles.includes("Company") &&
            !userDetails.roles.includes("Dealers") &&
            !userDetails.roles.includes("RegionalManager") &&
            !userDetails.roles.includes("Branch") &&
            !userDetails.roles.includes("SalesRep") &&
            !userDetails.roles.includes("RegionalEngineer") &&
            !userDetails.roles.includes("POS Owner") &&
            !userDetails.roles.includes("Customer") &&
            !userDetails.roles.includes("Account Manager") &&
            !userDetails.roles.includes("POS Bank") &&
            !userDetails.roles.includes("viewESales") &&
            !userDetails.roles.includes("IndustryManager") &&
            !userDetails.roles.includes("IndustryGroup") &&
            !userDetails.roles.includes("Team") &&
            !userDetails.roles.includes("GroupBranchList") &&
            !userDetails.roles.includes("IndustryAdmin") &&
            !userDetails.roles.includes("SupportAdmin") &&
            !userDetails.roles.includes("PartnerAdmin")
          ) {
            this.$toast.error(this.$t("text.accountConfirmation.noAccess"));
            return;
          }

          this.$store.commit("setUserInfo", userDetails);
          var decoded = jwt_decode(userDetails.token);
          const exp = decoded.exp * 1000;
          localStorage.setItem("jwtExpiry", exp);
          localStorage.setItem("color", "#370f70");
          this.$store.commit("setDatePickerColor", "#370f70");

          const viewOnly = userDetails.roles.includes("View Only");
          this.$store.commit("setViewOnly", viewOnly);
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
          this.$toast.success(this.$t("text.login.loginSuccessful"));

          if (userDetails.roles.includes("IndustryManager")) {
            this.$router.push({ name: "IndustrialBranchDashboard" });
          } else if (userDetails.roles.includes("IndustryGroup")) {
            this.$router.push({ name: "industrial_group_dashboard" });
          } else if (userDetails.email == "demonstration@gmail.com") {
            this.$router.push({ name: "price_management" });
          } else if (this.allowedEmails.includes(userDetails.email)) {
            this.$router.push({ name: "manage_price" });
          } else if (userDetails.roles.includes("IndustryAdmin")) {
            this.$router.push({ name: "industrial_admin_dashboard" });
          } else if (userDetails.roles.includes("PartnerAdmin")) {
            this.$router.push({ name: "supportCompanies" });
          } else if (userDetails.roles.includes("SupportAdmin")) {
            this.$router.push({ name: "supportCompanies" });
          } else if (userDetails.roles.includes("Company")) {
            this.$router.push({ name: "companyDashboard" });
          } else if (userDetails.roles.includes("Dealers")) {
            this.$router.push({ name: "dealerDashboard" });
          } else if (userDetails.roles.includes("RegionalManager")) {
            this.$router.push({ name: "regionDashboard" });
          } else if (userDetails.roles.includes("Branch")) {
            this.$router.push({ name: "branchDashboard" });
          } else if (
            userDetails.roles.includes("Sub Branch Manager") &&
            userDetails.roles.includes("manualRecords") &&
            !userDetails.roles.includes("Branch")
          ) {
            this.$router.push({ name: "manualRecord" });
          } else if (userDetails.roles.includes("GroupBranchList")) {
            this.$router.push({ name: "groupBranches" });
          } else if (
            userDetails.roles.includes("SalesRep") ||
            userDetails.roles.includes("RegionalEngineer") ||
            userDetails.roles.includes("Team")
          ) {
            this.$router.push({ name: "groupDashboard" });
          } else if (userDetails.roles.includes("Sub Branch Manager")) {
            this.$router.push({ name: "branchDashboard" });
          } else if (userDetails.roles.includes("POS Owner")) {
            this.$router.push({ name: "pos-owner-transactions" });
          } else if (userDetails.roles.includes("POS Bank")) {
            this.$router.push({ name: "pos-bank-transactions" });
          } else if (userDetails.roles.includes("viewESales")) {
            this.$router.push({ name: "branch_wallet" });
          } else if (
            userDetails.roles.includes("Customer") ||
            userDetails.roles.includes("Account Manager")
          ) {
            this.$store.commit("setUserRole", userDetails.roles);
            this.$router.push({ name: "userDashboard" });
          }
        })
        .catch((error) => {
          this.disableButton = false;

          if (error.response.data.message == "ForcePasswordChange") {
            this.$toast.open({
              message:
                error.response.data.message == "ForcePasswordChange"
                  ? "You need to reset your password to continue using the portal"
                  : null,
              type: "error",
              duration: 15000,
            });
            this.$router.push({ path: "/Account/reset-password-request" });
          } else {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 15000,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.right-slide-enter-active {
  transition: all 0.9s ease;
}
.right-slide-leave-active {
  transform: translateX(50px);
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.right-slide-enter,
.right-slide-leave-to {
  transform: translateX(-50px);
  opacity: 0;
}
</style>
